import { render } from "./BrandAntenneKaernten.vue?vue&type=template&id=56b8898b"
import script from "./BrandAntenneKaernten.vue?vue&type=script&lang=ts"
export * from "./BrandAntenneKaernten.vue?vue&type=script&lang=ts"

import "./BrandAntenneKaernten.vue?vue&type=style&index=0&id=56b8898b&lang=scss"
script.render = render

export default script